import React, { useState } from 'react';
import { Card, Button, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import GridOcorrencias from '~/Components/Ocorrencias/GridOcorrencias';
import moment from 'moment';

const TAMANHO_PAGINA = 50;

/**
 * Painel alternativo (modo Cliente/Texto) — grid único paginado, ordenável.
 */
const PainelClienteTexto = ({
  dados,
  total,
  pagina,
  ordenacao,
  onOrdenacaoChange,
  onPaginaChange,
  onFechar,
  onImprimir,
}) => {
  const colunas = [
    { key: 'titulo', label: 'Título' },
    {
      key: 'data_ocorrencia',
      label: 'Data',
      width: 100,
      render: (item) =>
        item.data_ocorrencia ? moment(item.data_ocorrencia).format('DD/MM/YYYY') : '',
    },
    { key: 'apelido_conta', label: 'Conta' },
    { key: 'nome_usuario', label: 'Usuário' },
    { key: 'texto_ocorrencia', label: 'Texto', wrap: true },
  ];

  return (
    <Card className="shadow-sm mb-3">
      <Card.Header className="d-flex justify-content-between align-items-center py-2">
        <strong style={{ fontSize: 13 }}>Ocorrências — Modo Cliente/Texto</strong>
        <div style={{ gap: 6 }} className="d-flex">
          <Button size="sm" variant="outline-primary" onClick={onImprimir}>
            Imprimir Lista Completa
          </Button>
          <Button size="sm" variant="outline-secondary" onClick={onFechar}>
            Voltar
          </Button>
        </div>
      </Card.Header>
      <Card.Body className="p-2">
        <GridOcorrencias
          dados={dados}
          total={total}
          pagina={pagina}
          colunas={colunas}
          comSel={false}
          onPaginaChange={onPaginaChange}
        />
      </Card.Body>
    </Card>
  );
};

export default PainelClienteTexto;
